import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { message,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker   } from 'antd';


import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';
import left from '../../assets/images/icon/next.png';
import right from '../../assets/images/icon/return.png';
import person from '../../assets/images/icon/person.png';

const CheckboxGroup = Checkbox.Group;
const { TextArea } = Input;
const { Panel } = Collapse;

const buttonWidth = 70;

const plainOptions = ['Apple', 'Pear', 'Orange'];
const defaultCheckedList = ['Apple', 'Orange'];

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}
const item_name = [];
function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
  const item_name = checkedValues;
}

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			item_name: item_name,
			value: '',
			checkedList: defaultCheckedList,
			indeterminate: true,
			checkAll: false,
			tabs: '1',
			school_list: [],
			program_list: [],
		}
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'],school_id : storedArray['data'][0]['school_id'] });
		
		}
		this.checkData();
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			var app = {user_id : user_id,school_id:school_id}
			getData('erp/program_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							program_list: result['data'],
							program_id: result['data'][0]['id'],
						});
					}else{
						this.setState({
							program_list: [],
							
						});
					}
					var app_ = {user_id : user_id,program_id:this.state.program_id}
					getData('erp/student_list_',app_).then((result) => {
						let responseJson = result;
						if(responseJson.data){
							if(result['status'] == 200){
								this.setState({
									school_list: result['data'],
								});
								
							}else{
								this.setState({
									school_list: [],
									
								});
								
							}
						}
					});
							
						}
					});
			
	}
  }
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	  };
	
	onChange = checkedList => {
		this.setState({
		  checkedList,
		  indeterminate: !!checkedList.length && checkedList.length < plainOptions.length,
		  checkAll: checkedList.length === plainOptions.length,
		});
	  };

  onCheckAllChange = e => {
		this.setState({
		  checkedList: e.target.checked ? plainOptions : [],
		  indeterminate: false,
		  checkAll: e.target.checked,
		});
	  };
	  
	openQuantity(e){
		this.setState({ program_id: e });
		var app_ = {user_id : this.state.user_id,program_id:e}
					getData('erp/student_list_',app_).then((result) => {
						let responseJson = result;
						if(responseJson.data){
							if(result['status'] == 200){
								this.setState({
									school_list: result['data'],
								});
								
							}else{
								this.setState({
									school_list: [],
									
								});
								
							}
						}
					});
	} 

	Export = () => {
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			var program_id = this.state.program_id;
			
			var app = {user_id : user_id,school_id:school_id,program_id:program_id}
			getData('Phpspreadsheet/export_allergies',app).then((result) => {
				let responseJson = result;
				if(responseJson){
					message.config({ top: 150});
					message.success('File Downloaded',2);	
					window.open(responseJson.file_link);
				}
			});
		}
	}	
	
	render()

	{
	var lenght = this.state.school_list.length; 
	const { size } = this.state;
	const content = (
					  <div>
						<p className="center upload-img"><Tooltip placement="right" title="Audio"><img src={music} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Pdf"><img src={pdf_} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Image"><img src={image} class="" alt="image" /></Tooltip></p>
						
					  </div>
					);
		return (
			<div class="mobile_view">
			
			<div id="main" class="bg-off">
         <div class="row">
		 
		  <div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
                     
					  <div class="col s12 m6 l6 pb-15 mt-5">
                        <h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">Allergies Info</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
                        <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
                           <li class="breadcrumb-item active">Allergies Info
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
            
		 
        <div class="desktop-view">  
           
		 	<div class="col s12 m12 ex-padd"> 
			<div id="main" class="bg-off">
				<div class="row">
				<div class="container">
					<div class="col m12 mt-10 mb-10 pb-10">
						<div class="col m2 s2 no-padd">
							<img src={right} class="atn-img"/>
						</div>
						<div class="col m8 s8 center">
						 {this.state.program_list.map((list) => ( 
							 <Button className={`snd-btn staff untag ${this.state.program_id != list.id ?'bg-color-none':''} ${this.state.student_in != '1'?'':'disabled'}`} onClick={this.openQuantity.bind(this,list.id)}>{list.name}</Button>	
							))}
						</div>
						<div class="col m2 s2 no-padd">
							<img src={left} class="atn-img right"/>
						</div>
					</div>
					
				</div>
				</div>
				<div class="row">
				<div class="container">
					<div class="col m12 mt-10 mb-10 text-right">
							<Button className="snd-btn " onClick={this.Export}>Download</Button>
					</div>
				</div>
				</div>
			</div>
			</div>
		
		 <div class="col s12 m12 ex-padd">	
            <div class="container ">
			   <div class="col s12 m12 mb-20 card-content iq-card mh-500">
                  <section class="invoice-list-wrapper section food">
					
					<div class="children bg-blue notice center">
						{this.state.school_list.map((list) => ( 
						
						<div class="col m4 s5 pt-10 center " >
						<div class="alergies-card">
							<div class="col m2 s2 no-padd"><h6>{(() => {
												if (list.profile_pic != '') {
													return (
														<img src={list.profile_pic} class="tags-img" /> 
													)
												}else{
													return (
														<img src={person} class="tags-img" /> 
													)
												}
											})()}  </h6></div>
							<div class="col m10 s10 text-left">
								<h6>{list.first_name} {list.last_name}</h6>
								<p>{list.allergies}</p>
							</div>
						</div>
						</div>
						
						))}
						
						{(() => {  
											if (lenght =='0') {
											return (
											<h6 id="error">No Student Found</h6>
													)
												}
											})()}
						
						
						
					</div>	
					
					
					
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
		</div>	
		
		<div class="mobile-view">  
           
		 	<div class="col s12 m12 ex-padd"> 
			<div id="main" class="bg-off">
				<div class="row">
				<div class="container">
					<div class="mobile-tab">
								{this.state.program_list.map((list) => ( 
								<div className={`mobile-tab-view ${this.state.program_id == list.id ?'':'tab-none'} `} onClick={this.openQuantity.bind(this,list.id)} >
								{list.short_name}</div>	
								))}
								</div>
					
				</div>
				</div>
			</div>
			</div>
		
		 <div class="col s12 m12 ex-padd">	
            <div class="container ">
			   <div class="col s12 m12 mb-20 card-content iq-card mh-500">
                  <section class="invoice-list-wrapper section food">
					
					<div class="children bg-blue notice">
					
						
						
								{this.state.school_list.map((list) => (
								<div class="col m12 s12 mt-10 bb tag-div bg-white no-padd">
									<a >
										<div class="col m12 s12 pt-10 ">
											{(() => {
												if (list.profile_pic != '') {
													return (
														<img src={list.profile_pic} class="tags-img" /> 
													)
												}else{
													return (
														<img src={person} class="tags-img" /> 
													)
												}
											})()} 
											{list.first_name} {list.last_name}
										</div>
										<div class="col m12 s12 ">
											<p class="fw-0 mt-5">{list.allergies}</p>
										</div>	
									</a>
								</div>
								))}
								
								
						
						{(() => {  
											if (lenght =='0') {
											return (
											<h6 id="error" class="mt-20 center">No Student Found</h6>
													)
												}
											})()}
						
						
						
					</div>

					<div class="notice-left">
							<p onClick={this.Export} class="btn-floating btn-large gradient-45deg-light-blue-cyan "><i class="material-icons">download</i></p>
					</div>
					
					
					
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
		</div>	
			
			
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
